type SwitchCaseReturn<U> = U extends (...args: never[]) => unknown ? U : () => U;

export const switchCase = <T extends string | number, U>(cases: Partial<Record<T, U>>) => (key: T): SwitchCaseReturn<U> => {
    const value = cases[key];
    if (value === undefined) {
        return (() => undefined) as SwitchCaseReturn<U>;
    }
    return typeof value === 'function' ? value as SwitchCaseReturn<U> : (() => value) as SwitchCaseReturn<U>;
};
